

import React, { useState } from "react";

function FormatDecimal(props)
{

    var n = props.value

    n = Math.round(n * 100) / 100;

    n = parseFloat(n).toFixed(2);

    var str = "" + n;
    str = str.replace('.', ',')
    

    return <React.Fragment>
        {str}
    </React.Fragment>
}

export default FormatDecimal;